import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

export const PieChart = ({ dataValue, dataCount }) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 10,
          boxHeight: 10,
          pointStyle: "circle",
          usePointStyle: true,
        },
      },
    },
  };

  const data = {
    labels: dataValue,
    datasets: [
      {
        label: "# of Votes",
        data: dataCount,
        backgroundColor: ["#FEA3B4", "#A6EF67", "#FDE272", "#84ADFF"],
      },
    ],
  };
  return <Pie data={data} options={options} />;
};
